export default __webpack_public_path__ + "static/media/nmd-collection_mobile.9e605dfb.png";